/**
 * Customize this file — each item is one level.
 * Exactly one visible choice should have correct: true unless the level uses a special answer.
 */
export const INITIAL_LIVES = 3;

export const QUESTIONS = [
  {
    prompt: "When is Vale's Birthday?",
    choices: [
      { text: 'Every day', correct: false },
      { text: "I don't know", correct: false },
      { text: 'May 22nd', correct: true },
      { text: 'February 30th', correct: false },
    ],
  },
  {
    prompt: 'Vale is a',
    choices: [
      { text: 'Boy', correct: false },
      { text: 'Girl', correct: false },
      { text: 'Worm', correct: false },
      { text: 'Baby', correct: true },
    ],
  },
  {
    prompt: 'Vale has a boyfriend',
    choices: [
      { text: 'True', correct: true },
      { text: 'False', correct: false },
    ],
  },
  {
    prompt: 'Vale has a handsome boyfriend',
    choices: [
      { text: 'True', correct: true },
      { text: 'False', correct: false },
    ],
  },
  {
    prompt: 'Where is Vale from?',
    choices: [
      { text: 'Her mom', correct: true },
      { text: 'Space dust', correct: false },
      { text: 'Mexico', correct: false },
      { text: 'Cotton eye joe?', correct: false },
    ],
  },
  {
    prompt: "What's her favorite animal?",
    choices: [
      { text: 'Dog', correct: false },
      { text: 'Cat', correct: false },
      { text: 'Frog', correct: false },
      { text: 'Red Panda', correct: false },
      { text: 'All of them!', correct: true, secret: true },
    ],
  },
  {
    prompt: '6',
    promptBlank: true,
    questionNumberCorrect: true,
    choices: [
      { text: 'is bigger than 3', correct: false },
      { text: '-y time', correct: false },
      { text: "... I don't get it", correct: false },
      { text: 'is how old Vale is', correct: false },
    ],
  },
  {
    prompt: "When is her boyfriend's birthday?",
    sequenceAnswer: ['0', '2', '2', '7', '0', '4'],
    choices: [
      { text: '0', correct: false },
      { text: '2', correct: false },
      { text: '7', correct: false },
      { text: '4', correct: false },
    ],
  },
  {
    prompt: "True or false: What's Vale's favorite food?",
    choices: [
      { text: 'True', correct: false },
      { text: 'Cheemse', correct: false },
      { text: 'Me (Corey)', correct: true },
      { text: 'False', correct: false },
    ],
  },
  {
    prompt: 'How many babies does Vale have?',
    choices: [
      { text: 'None (hi mom and dad)', correct: false },
      { text: 'Not nearly enough!', correct: true },
      { text: '3', correct: false },
      { text: 'How are babies made?', correct: false },
    ],
  },
  {
    prompt: 'Quickly! Letters: 3, 12, 22, 13',
    timerSeconds: 10,
    typingAnswer: 'CLVM',
    choices: [],
  },
  {
    prompt: 'One of these things is not like the other',
    timerSeconds: 10,
    choices: [
      { text: 'Dongy', correct: false },
      { text: 'Feesh', correct: false },
      { text: 'Cat', correct: true },
      { text: 'Mongy', correct: false },
    ],
  },
  {
    prompt: 'How many times has Vale thinkded?',
    timerSeconds: 10,
    choices: [
      { text: '3', correct: false },
      { text: 'Once upon a time', correct: false },
      { text: "Uhhh, I don't know", correct: true },
      { text: "She's always thinking", correct: false },
    ],
  },
  {
    prompt: 'Quick! Press this button!',
    timerSeconds: 1,
    pressButtonText: 'Press me',
    choices: [],
  },
  {
    prompt: "Vale's favorite color is",
    timerSeconds: 10,
    choices: [
      { text: 'Mac and Cheemse', correct: false },
      { text: 'Burgundy', correct: false },
      { text: 'Rainbow', correct: false },
      { text: 'Light Black', correct: true },
    ],
  },
  {
    prompt: 'Pick one to burn',
    pantsChoices: [
      { text: 'Jeans', style: 'jeans', correct: false },
      { text: 'Adidas running pants', style: 'adidas', correct: true },
      { text: 'Beach shorts', style: 'shorts', correct: false },
      { text: 'Dress pants', style: 'dress', correct: false },
    ],
    choices: [],
  },
  {
    prompt: "Why can't dogs see rainbows?",
    timerSeconds: 10,
    choices: [
      { text: "Rainbows aren't good enough for them", correct: true },
      { text: 'Because they have no eyes', correct: false },
      { text: 'Yes they can!', correct: false },
      { text: "They're colorblind", correct: false },
    ],
  },
  {
    prompt: 'Name the best duo',
    timerSeconds: 10,
    choices: [
      { text: 'Noah and Maia', correct: false },
      { text: 'Valeria and Corey', correct: true },
      { text: 'Righty and Lefty', correct: false },
      { text: 'Chanie and Tzvi', correct: false },
    ],
  },
  {
    prompt: 'Only lucky people win',
    timerSeconds: 10,
    choices: [
      { text: 'Pick me!', correct: false },
      { text: 'Pick me!', correct: false },
      { text: 'Pick me!', correct: true },
      { text: 'Pick me!', correct: false },
    ],
  },
  {
    prompt: 'Which is a child?',
    timerSeconds: 10,
    choices: [
      { text: 'Redy', correct: false },
      { text: 'Orangey', correct: false },
      { text: 'Yellowy', correct: false },
      { text: 'Bluey', correct: true },
    ],
  },
  {
    prompt: 'Are you ready for the final question?',
    choices: [
      { text: 'Yes', correct: false },
      { text: 'No', correct: true },
    ],
  },
  {
    prompt: 'Corey loves Valeria more',
    preludeText:
      'The final question can be the easiest or hardest in the entire quiz depending on your ability to find the truth hidden within yourself',
    timerSeconds: 10,
    choices: [
      { text: 'Maybe', correct: true },
      { text: 'False', correct: false },
    ],
  },
  // Looks like question 1, but is question 24 (shown after the trick win screen).
  {
    prompt: "When is Vale's Birthday?",
    timerSeconds: 10,
    choices: [
      { text: 'Every day', correct: true },
      { text: "I don't know", correct: false },
      { text: 'May 22nd', correct: false },
      { text: 'February 30th', correct: false },
    ],
  },
  // Question 25 — copy of question 2 for now.
  {
    prompt: 'Vale is a',
    timerSeconds: 10,
    choices: [
      { text: 'Boy', correct: false },
      { text: 'Girl', correct: true },
      { text: 'Worm', correct: false },
      { text: 'Baby', correct: false },
    ],
  },
  // Question 26 — copy of question 3 for now.
  {
    prompt: 'Did the game really start over?',
    timerSeconds: 10,
    choices: [
      { text: 'Yes', correct: false },
      { text: 'No', correct: false },
      { text: 'Maybe', correct: false },
      { text: 'Only if I lose', correct: true },
    ],
  },
  // Question 27
  {
    prompt: 'Snug as a bug in a',
    promptBlank: true,
    preludeText: "In fact, you aren't even half way there...",
    timerSeconds: 10,
    choices: [
      { text: 'Terrarium', correct: false },
      { text: 'Carpet', correct: false },
      { text: 'Rug', correct: true },
      { text: 'Loving Home', correct: false },
    ],
  },
  // Question 28
  {
    prompt: 'I go to the gym to become',
    timerSeconds: 10,
    choices: [
      { text: 'Stronger', correct: false },
      { text: 'Buffy', correct: true },
      { text: 'A better version of myself', correct: false },
      { text: 'Jim', correct: false },
    ],
  },
  // Question 29 — hidden scatter words; find "3"
  {
    prompt: 'Find the biggest',
    choices: [],
    scatterChoices: [
      { text: 'My Ego', correct: false },
      { text: '3', correct: true },
      { text: 'An Elephant', correct: false },
      { text: 'A Lelephant', correct: false },
      { text: 'America', correct: false },
      { text: 'Infinity', correct: false },
      { text: 'Like a Bajillion?', correct: false },
      { text: 'Because 7 8 9', correct: false },
      { text: 'My Peentis', correct: false },
    ],
  },
  // Question 30
  {
    prompt: 'Im sad because I',
    preludeText: 'Remember: 2, 19, 25, 11, 7, 3',
    timerSeconds: 10,
    choices: [
      { text: 'Mims you', correct: true },
      { text: 'Miss you', correct: false },
      { text: 'Lomve you', correct: false },
      { text: 'Love you', correct: false },
    ],
  },
  // Question 31 — survive the green bomb; pressing the button kills you
  {
    prompt: "Quick! Dont press this button!",
    timerSeconds: 3,
    timerAdvances: true,
    pressButtonText: 'Dont press me',
    pressButtonKills: true,
    choices: [],
  },
  // Question 32
  {
    prompt: 'What is love?',
    timerSeconds: 10,
    choices: [
      { text: 'What I hold in my heart for you', correct: true },
      { text: 'Baby dont hurt me!', correct: false },
      { text: 'A feeble, fleating thing', correct: false },
      { text: 'What is anything?', correct: false },
    ],
  },
  // Question 33 — answer is clicking the question number
  {
    prompt: 'The only thing bigger than 3 is',
    timerSeconds: 10,
    questionNumberCorrect: true,
    choices: [
      { text: 'The universe', correct: false },
      { text: '3', correct: false },
      { text: '2?', correct: false },
      { text: 'Yo mama!', correct: false },
    ],
  },
  // Question 34
  {
    prompt: 'Why did the chicken cross the road?',
    timerSeconds: 10,
    choices: [
      { text: 'Do you mean Chimken?', correct: false },
      { text: 'To get to the huggies', correct: true },
      { text: 'Mmm, chicken nuggets', correct: false },
      { text: 'He has places to be', correct: false },
    ],
  },
  // Question 35 — Chrome-dino-style runner inside the card
  {
    prompt: 'Reach 1000!',
    runnerGame: true,
    runnerTargetScore: 1000,
    choices: [],
  },
  // Question 36 — trap ending if they try to skip ahead
  {
    prompt: 'If you want, you can win the quiz right now! All you have to do is say you want to.',
    choices: [
      { text: 'I want to', correct: false, trapEnding: true },
      { text: 'Lets keep going!', correct: true },
    ],
  },
  // Question 37
  {
    prompt: 'What was question 15?',
    timerSeconds: 10,
    choices: [
      { text: 'Her boyfriends birthday', correct: false },
      { text: "Who's the best couple", correct: false },
      { text: 'Think fast!', correct: false },
      { text: "Asking for Vale's favorite color", correct: true },
    ],
  },
  // Question 38
  {
    prompt: 'How tall is Vale?',
    timerSeconds: 10,
    choices: [
      { text: 'About yea high', correct: false },
      { text: "5' on the dot", correct: false },
      { text: `5' 1"`, correct: true },
      { text: 'Supa dupa tiny', correct: false },
    ],
  },
  // Question 39
  {
    prompt: 'Where is Vales home?',
    timerSeconds: 10,
    choices: [
      { text: 'Mexico', correct: false },
      { text: 'NYC', correct: false },
      { text: 'Wherever her Hubby is', correct: true },
      { text: 'Everywhere and anywhere!', correct: false },
    ],
  },
  // Question 40 — toggle bomb color; green advances, red kills
  {
    prompt: '',
    timerSeconds: 10,
    bombColorToggle: true,
    pressButtonText: 'Switch',
    choices: [],
  },
  // Question 41
  {
    prompt: "What's better?",
    timerSeconds: 10,
    choices: [
      { text: 'Hugs', correct: false },
      { text: 'Kisses', correct: false },
      { text: 'Cuddles', correct: false },
      { text: 'All of them!', correct: true },
    ],
  },
  // Question 42
  {
    prompt: 'What is the meaning of the life, the universe, and everything?',
    timerSeconds: 10,
    questionNumberWrong: true,
    choices: [
      { text: 'HaShem', correct: false },
      { text: 'The question number', correct: false },
      { text: 'Huggies', correct: true },
      { text: 'Poetry', correct: false },
    ],
  },
  // Question 43
  {
    prompt: 'What do aminals thonk?',
    timerSeconds: 10,
    choices: [
      { text: 'Food', correct: false },
      { text: 'Nothing', correct: false },
      { text: 'I love you!', correct: true },
      { text: 'Ruff', correct: false },
    ],
  },
  // Question 44 — pet that dawg mini-game
  {
    prompt: 'Pet that dawg!',
    petDawgGame: true,
    petDawgTarget: 14,
    choices: [],
  },
  // Question 45
  {
    prompt: 'Would you pet just any dawg?',
    timerSeconds: 10,
    choices: [
      { text: 'Of course!', correct: true },
      { text: 'Only friendly ones', correct: false },
      { text: 'My dawgs only!', correct: false },
      { text: 'I want a dawg :(', correct: false },
    ],
  },
  // Question 46
  {
    prompt: 'How many pets does Vale have?',
    timerSeconds: 10,
    choices: [
      { text: '2', correct: false },
      { text: '3', correct: true },
      { text: '4', correct: false },
      { text: 'So so many', correct: false },
    ],
  },
  // Question 47
  {
    prompt: 'Why did the vale cross the road?',
    timerSeconds: 10,
    choices: [
      { text: 'To be with the chimken', correct: false },
      { text: 'She chasing a butterfly', correct: true },
      { text: 'Why?', correct: false },
      { text: "She doesn't know", correct: false },
    ],
  },
  // Question 48 — kiss-a-mole mini-game
  {
    prompt: 'Kiss-a-Mole',
    kissAMoleGame: true,
    kissAMoleTarget: 5,
    choices: [],
  },
  // Question 49
  {
    prompt: 'Corey is a',
    timerSeconds: 10,
    choices: [
      { text: 'Doctah', correct: false },
      { text: 'Scientist', correct: false },
      { text: 'Coder', correct: false },
      { text: 'Cheerleader', correct: true },
    ],
  },
  // Question 50 — date combination from the remember hint
  {
    prompt: '',
    timerSeconds: 30,
    choices: [],
    dateCombination: {
      answer: [2, 19, 25, 11, 7, 3],
      dates: [
        { label: 'Ballroom Dance', month: 11, day: 19 },
        { label: 'First Date', month: 2, day: 25 },
        { label: 'Anniversary', month: 3, day: 7 },
      ],
    },
  },
];
